







































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import * as types from "@/store/constants/index_types";
import * as setting_types from "@/store/constants/setting_types";
import * as cg_user_types from "@/store/constants/cg_user_types";
import * as GeneralUtilsHelper from "@/utils/general_utils";
import { goToVip } from "@/utils/router_helper";
import { payByAny } from "@/services/payment/payment_check/payment_check_logic";

@Component({
  components: {}
})
export default class VipPackages extends Vue {
  @Getter(setting_types.GETTER_TAB_COIN_STORE_SETTINGS)
  private tabCoinStore: any;
  @Getter(types.GETTER_CURRENT_USER_ID)
  private currentUserId: any;
  @Getter(cg_user_types.GETTER_VIP_VALID_COUNT)
  private vip_valid_count: any;
  @Getter(cg_user_types.GETTER_VIP_VALID_TIME)
  private vip_valid_time: any;
  @Action(cg_user_types.UPDATE_VIP_PACKAGE_STATUS)
  private updateVipPackageStatus: any;

  get vip_package_offers() {
    return this.tabCoinStore && this.tabCoinStore.vip_package_offers;
  }

  get effective_package_offer() {
    return (
      this.vip_package_offers &&
      this.vip_package_offers.find((v: any) => v.vip_package)
    );
  }

  private async buyCoins() {
    if (GeneralUtilsHelper.isVip()) {
      // 默认一次没有购买vippackage，vip_valid_time为null
      const isVipCountValid: boolean =
        this.vip_valid_count > 0 &&
        (this.vip_valid_time >= new Date().valueOf() ||
          !Boolean(this.vip_valid_time));
      if (isVipCountValid) {
        payByAny({ offer: this.effective_package_offer });
      } else {
        this.$_Dialog.show({
          avatar: require("@/assets/icons-file/vip/lh_alert_soldout.png"),
          title: "Come Back Next Month",
          content: {
            text:
              "Sorry, VIP package is out of stock. This item is <%refreshed monthly./%>",
            highlightColor: "rgb(79, 121, 255)"
          },
          closable: true,
          closeOnClickModal: true,
          onConfirm(done: any) {
            done();
          }
        });
      }
    } else {
      goToVip("vippackage_pop");
    }
  }

  private async toVIP() {
    this.$router.push({
      name: "VipDiscount",
      query: {
        routerTransition: "up"
      }
    });
  }

  private async created() {
    await this.updateVipPackageStatus();
  }
}
